import { gql } from '@apollo/client';

const BRANDS_QUERY = gql`
    query brands {
        brands {
            edges {
                node {
                    id
                    name
                    slug
                    segmentId 
                }
            }
        }
    }
`;

export default BRANDS_QUERY;
